import app from 'flarum/forum/app';
import { formatDate } from '../../utils/format';
import { tt, find, onLocaleChange } from '../../i18n';

// Soorten verhalen; de labels staan in locale/*.yml (dark.kind.*).
export const KINDS = ['dood', 'geweld', 'drugs', 'razzia', 'brand', 'rechtszaak', 'sluiting', 'ongeval', 'ontvoering', 'misdaad', 'ramp', 'persoonlijk'];

export function kindLabel(kind) {
  return KINDS.includes(kind) ? tt(`dark.kind.${kind}`) : tt('dark.story');
}

/** Datum zoals bekend: "vr 25 maart 1994", "maart 1994" of "1994". */
export function storyDate(story) {
  return story.date() ? formatDate(story.date()) : story.year() ? String(story.year()) : '';
}

export function clubName(slug) {
  const club = app.store.all('lc-clubs').find((c) => c.slug() === slug);
  return club ? club.name() : null;
}

/** Laadt alle gepubliceerde verhalen één keer per taal (lijst is klein). */
let loading = null;
onLocaleChange(() => (loading = null));
export function loadStories() {
  if (!loading) loading = find('lc-dark-stories').then((r) => r);
  return loading;
}

export function chronological(stories) {
  return stories.slice().sort((a, b) => String(a.date() || a.year() || '').localeCompare(String(b.date() || b.year() || '')) || a.title().localeCompare(b.title(), 'nl'));
}
